/**
 * 道具数据管理器
 */
ItemDataManager = xClass('ItemDataManager');
/**
 * 初始化
 * @param data  道具列表
 */
ItemDataManager.initialize = function (data) {
    this.itemData = table()
    for (let i in data) {
        this.itemData[i] = data[i]
        var item = this.itemData[i]
        var coin = item.coin.split(':')
        item.payType = coin[0] === "2" ? this.PayTypeEnum.Coin : this.PayTypeEnum.Cash
        item.price = coin[1]
    }
}
/**
 * 获取主线关卡关前道具类型
 */
ItemDataManager.getMainLevelInitProp = function () {
    return ItemDataManager.mainLevelInitProp
}
/**
 * 设置主线关卡关前道具类型
 * @param   propsTypes  主线关卡道具列表
 */
ItemDataManager.setMainLevelInitProp = function (propsTypes) {

    ItemDataManager.mainLevelInitProp = table()

    for (let i in propsTypes) {
        ItemDataManager.mainLevelInitProp[i] = propsTypes[i].split(':')
    }
}
/**
 * 通过ItemID获取其对应的道具ID
 */
ItemDataManager.getPropIdByItemId = function (itemId) {
    return ItemDataManager.itemData[itemId].propId
}
/**
 * 获取主线关卡关前道具类型
 */
ItemDataManager.getItemPayType = function (itemId) {
    let item = ItemDataManager.itemData[itemId]
    if (item) {
        return item.payType
    } else {
        return ItemDataManager.PayTypeEnum.Unsupport
    }
}
/**
 * 通过物品编号获取物品信息
 * @param itemId    物品编号
 */
ItemDataManager.getItemDataById = function (itemId) {
    if (this.itemData[itemId]) {
        return this.itemData[itemId]
    } else {
        return null
    }
}
/**
 * 读取关前道具配置
 */
ItemDataManager.loadPrePropData = function () {
    function onSuccess(evt) {
        ItemDataManager.initialize(evt.data.propsBeans)
        ItemDataManager.setMainLevelInitProp(evt.data.propsTypes)
        MetaManager.setGameModeInitProp(ItemDataManager.getMainLevelInitProp())
    }
    function onError() {
        cc.log("加载关前道具配置失败")
    }

    function onCancel() {
        cc.log("取消关前道具配置")
    }
    var http = GetPropConfigHttp.new(false)
    http.addEventListener(Events.kComplete, onSuccess)
    http.addEventListener(Events.kError, onError)
    http.addEventListener(Events.kCancel, onCancel)
    http.load()
}
/**
 * 道具支付方式
 */
ItemDataManager.PayTypeEnum = {
    Coin: 2,
    Cash: 14,
    Unsupport: -1
}